export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('vue:error', (err, instance, info) => {
    console.error('[ERROR HANDLER] Vue error:', err, info)
    if (err && err.stack) {
      console.error('[ERROR HANDLER] Stack:', err.stack)
    }
  })

  nuxtApp.hook('app:error', (err) => {
    console.error('[ERROR HANDLER] Nuxt app error:', err)
    if (err && err.stack) {
      console.error('[ERROR HANDLER] Stack:', err.stack)
    }
  })
})
